module.exports = __webpack_public_path__ + "static/img/wals.1113437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wals.png
// module id = 7pg9
// module chunks = 0